const couponCodes = (state = null, action) => {
    if (action.type === "SET_COUPON_CODES") {
        return action.payload;
    } else {
        return state;
    }
};

export default couponCodes;
